import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Instagram, Facebook } from "lucide-react";
import { BRAND, WHATSAPP_LINK } from "../brand";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0a0a0a] text-[#f7f5f2] mt-24 pt-20 pb-12 grain"
    >
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-12 pb-16 border-b border-white/10">
          <div className="md:col-span-5">
            <div className="font-display text-6xl md:text-7xl font-black tracking-tighter lowercase text-white leading-none">
              {BRAND.name}
              <span className="text-[#c45b3e]">.</span>
            </div>
            <p className="mt-6 font-display text-2xl md:text-3xl text-white/80 max-w-md leading-tight">
              {BRAND.tagline}
            </p>
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-whatsapp-btn"
              className="btn-whatsapp mt-8"
            >
              Talk to us on WhatsApp
            </a>
          </div>

          <div className="md:col-span-3">
            <p className="eyebrow text-white/50">Explore</p>
            <ul className="mt-6 space-y-3">
              {[
                { to: "/services", label: "Services" },
                { to: "/plans", label: "Subscription Plans" },
                { to: "/blog", label: "Blog" },
                { to: "/about", label: "About Us" },
                { to: "/contact", label: "Contact" },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-white/80 hover:text-white text-base font-medium link-underline"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="eyebrow text-white/50">Visit</p>
            <ul className="mt-6 space-y-4 text-white/80">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="mt-1 shrink-0 text-[#c45b3e]" />
                <span data-testid="footer-address">
                  {BRAND.city} — {BRAND.zones.join(", ")}. Kitchen support at your doorstep in 30 minutes.
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-[#c45b3e]" />
                <a
                  href={`tel:+${BRAND.whatsappCountry}${BRAND.whatsappNumberRaw}`}
                  data-testid="footer-phone-link"
                  className="link-underline"
                >
                  {BRAND.phoneDisplay}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} className="text-[#c45b3e]" />
                <a
                  href={`mailto:${BRAND.email}`}
                  data-testid="footer-email-link"
                  className="link-underline"
                >
                  {BRAND.email}
                </a>
              </li>
            </ul>
            <div className="mt-6 flex items-center gap-3">
              <a
                href={BRAND.instagramUrl}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-instagram-link"
                aria-label="Instagram @oolookitchen"
                className="p-3 rounded-full border border-white/15 hover:border-white/50 transition"
              >
                <Instagram size={16} />
              </a>
              <a
                href={BRAND.facebookUrl}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-facebook-link"
                aria-label="Facebook oolookitchen"
                className="p-3 rounded-full border border-white/15 hover:border-white/50 transition"
              >
                <Facebook size={16} />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-white/50 text-xs">
          <p>© {new Date().getFullYear()} ooloo kitchens. All rights reserved.</p>
          <p>Crafted in Lucknow · FSSAI compliant kitchens</p>
        </div>
      </div>
    </footer>
  );
};
